const typography = {
  body1: {
    fontWeight: "normal",
    fontSize: 18,
    letterSpacing: "-0.05px",
  },
  body2: {
    fontWeight: "normal",
    fontSize: 16,
    letterSpacing: "-0.05px",
  },
  caption: {
    fontWeight: "normal",
    fontSize: 12,
    letterSpacing: "-0.05px",
  },
  button: {
    fontWeight: "normal",
    fontSize: 16,
    letterSpacing: "-0.05px",
  },
  h1: {
    fontWeight: "bold",
    fontSize: 35,
    letterSpacing: "-0.24px",
  },
  h2: {
    fontWeight: "bold",
    fontSize: 29,
    letterSpacing: "-0.24px",
  },
  h3: {
    fontWeight: "bold",
    fontSize: 24,
    letterSpacing: "-0.06px",
  },
  h4: {
    fontWeight: "bold",
    fontSize: 22,
    letterSpacing: "-0.06px",
  },
  h5: {
    fontWeight: "bold",
    fontSize: 20,
    letterSpacing: "-0.05px",
  },
  h6: {
    fontWeight: "bold",
    fontSize: 18,
    letterSpacing: "-0.05px",
  },
  subtitle1: {
    fontWeight: "normal",
    fontSize: 16,
    letterSpacing: "-0.05px",
  },
  subtitle2: {
    fontWeight: "normal",
    fontSize: 14,
    letterSpacing: "-0.05px",
  },
  // 'inherit':,
  overline: {
    fontWeight: 500,
  },
};

export default typography;
